/* ==========================================================================
   RD: back to top

   Sits directly above the floating WhatsApp button, which is fixed at
   bottom 20px / left 20px at 60px square with z-index 9999. This one is
   smaller and one step up the same edge, so the pair reads as a stack with
   WhatsApp as the primary action.

   Hidden until there is something to scroll back from, and removed from the
   tab order while hidden rather than merely faded out.
   ========================================================================== */
(function () {
  'use strict';

  var SHOW_AFTER = 700;

  function init() {
    var btn = document.querySelector('[data-rd-top]');
    if (!btn) return;

    var visible = false;
    var ticking = false;

    function update() {
      ticking = false;
      var should = (window.pageYOffset || document.documentElement.scrollTop) > SHOW_AFTER;
      if (should === visible) return;
      visible = should;
      btn.classList.toggle('is-visible', visible);
      btn.setAttribute('aria-hidden', visible ? 'false' : 'true');
      btn.tabIndex = visible ? 0 : -1;
    }

    /* Throttled directly rather than through requestAnimationFrame. rAF does
       not run in a tab the browser is not painting, which makes the control
       impossible to verify in automation and would leave it stuck hidden in a
       background tab restored by the browser. A class toggle is cheap enough
       that the frame alignment buys nothing here. */
    var last = 0;
    function onScroll() {
      if (ticking) return;
      var now = (window.performance && window.performance.now)
        ? window.performance.now() : +new Date();
      if (now - last < 100) return;
      last = now;
      ticking = true;
      update();
    }

    btn.addEventListener('click', function () {
      var reduced = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      /* Return focus to the top of the document, otherwise a keyboard user is
         scrolled up but still tabbing from the bottom of the page. */
      var target = document.querySelector('main, #MainContent, header') || document.body;
      if (target && target.focus) {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
